import React, { useEffect, useState } from "react";

const SplashScreen = () => {
  return (
    <div className="splash-screen fade-in">
      <div className="text-center">

        <div className="logo-container">
          <div className="position-relative ">
            <img
              src={require("../assets/images/logos.webp")}
              className="position-absolute logo-wid-image-font"
              alt="Logo"
            />
            <img
              src={require("../assets/images/logos.webp")}
              className="position-absolute logo-wid-image-end"
              alt="Logo"
            />

          </div>

        </div>

      </div>

    </div>

  );
};

export default SplashScreen;
